'use strict';exports.__esModule = true;var _extends = Object.assign || function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};
var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _omit = require('lodash/omit');var _omit2 = _interopRequireDefault(_omit);
var _findIndex = require('lodash/findIndex');var _findIndex2 = _interopRequireDefault(_findIndex);
var _Select = require('react-select/lib/Select');var _Select2 = _interopRequireDefault(_Select);
var _reactScroll = require('react-scroll');
var _moment = require('moment');var _moment2 = _interopRequireDefault(_moment);


var _containers = require('../../containers');
var _TableRow = require('./TableRow');var _TableRow2 = _interopRequireDefault(_TableRow);
var _components = require('../../components');
var _scrollTo = require('../../utils/scrollTo');var _scrollTo2 = _interopRequireDefault(_scrollTo);

var _PropertiesTable = require('./PropertiesTable.scss');var styles = _interopRequireWildcard(_PropertiesTable);


var _helpers = require('./helpers');var _helpers2 = _interopRequireDefault(_helpers);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} // Modules
// Components
// Styles
// Helpers
_reactScroll.scroller.scrollTo = _scrollTo2.default.bind(_reactScroll.scroller);var PropertiesTable = function (_Component) {_inherits(PropertiesTable, _Component);
  function PropertiesTable(props) {_classCallCheck(this, PropertiesTable);var _this = _possibleConstructorReturn(this,
    _Component.call(this, props));_this.
































    getPagination = function (name) {
      if (typeof localStorage !== 'undefined') {
        try {
          var selectedPages = JSON.parse(localStorage.getItem(name));
          if (selectedPages) {
            _this.setState({ rowsOnPage: selectedPages });
          }
        } catch (e) {
          console.error('Failed to read ' + name + ' from localStorage');
        }
      }
    };_this.

    changePagination = function (value) {
      _this.setState({ rowsOnPage: value });
      var serializedVal = JSON.stringify(value);
      if (typeof localStorage !== 'undefined') {
        localStorage.setItem('rows-on-page', serializedVal);
      }
      _this.props.paginationUserProperties();
    };_this.

    scrollTo = function () {var element = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'anchor-top';var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      _reactScroll.scroller.scrollTo(element, Object.assign({
        duration: 500,
        smooth: true,
        offset: -55 },
      options));

    };_this.

    countSelectedProperties = function () {return _this.state.selectedProperties.length ? _this.state.selectedProperties.length + ' ' : '';};_this.

    transformFilteredNotions = function () {return _this.props.selectedColumns.map(function (item) {return item.name;});};_this.

    checkFilteredOption = function (el) {return _this.transformFilteredNotions().indexOf(el) !== -1;};_this.

    handleCheck = function (_ref)




    {var id = _ref.id,isActive = _ref.isActive,property = _ref.property,isForeignProperty = _ref.isForeignProperty;
      var selected = [];
      var properties = _this.state.selectedProperties;
      var index = (0, _findIndex2.default)(properties, function (item) {return item.id === id;});

      if (index !== -1) {
        properties.splice(index, 1);
        selected = properties;
      } else {
        selected = [].concat(properties, [{
          property: property,
          id: id,
          isActive: isActive,
          isForeignProperty: isForeignProperty }]);

      }

      _this.props.updateSelectedProperties(selected);
    };_this.

    scrollToTop = function () {
      if (_this.props.isMobile && _this.props.mobileFiltersIsOpen) {
        _this.props.closeMobileFilters();
        setTimeout(function () {return _this.scrollTo();}, 501);
      } else {
        _this.scrollTo();
      }
    };_this.

    handleForward = function () {
      var step = _this.props.currentPaginationStep + _this.state.rowsOnPage.value;
      if (step <= _this.props.propertiesCount) {
        _this.props.setCurrentPaginationStep(step);

        if (document) {
          _this.scrollToTop();
        }
      }
    };_this.

    handleBack = function () {
      var step = _this.props.currentPaginationStep - _this.state.rowsOnPage.value;
      _this.props.setCurrentPaginationStep(step > 1 ? step : 1);
      if (document && step >= 1) {
        _this.scrollToTop();
      }
    };_this.

    handleGoTo = function (val) {
      if (!Number.isNaN(val)) {
        if (Number(val) > _this.props.propertiesCount) return;
        _this.props.setCurrentPaginationStep(val);
        _this.setState({
          selected: val });

      }
    };_this.

    showMessageModal = function (remainingDays, formattedDate, activationAnotherPromotion) {return (
        _this.props.openMessageModal({ message:
          _react2.default.createElement('div', { className: styles.rocketMessageModalWrapper },
            _react2.default.createElement('div', { className: styles.iconWrapper },
              _react2.default.createElement('i', { className: 'icon icon-top-promotion-active' },
                _react2.default.createElement('span', { className: 'path1' }),
                _react2.default.createElement('span', { className: 'path2' })),

              _react2.default.createElement('p', null, '+'),
              _react2.default.createElement('i', { className: 'icon icon-rocket-active' })),

            _react2.default.createElement('div', { className: styles.title },

              activationAnotherPromotion ?
              _this.props.translate('rocketPromotion', 'promotionUsed') :
              _this.props.translate('rocketPromotion', 'promotionInUse')),


            !activationAnotherPromotion && _react2.default.createElement('div', { className: styles.infoPackage },
              _react2.default.createElement('p', { className: styles.text }, _this.props.translate('rocketPromotion', 'validUntil')),
              _react2.default.createElement('p', { className: styles.deteInfo }, formattedDate),
              _react2.default.createElement('p', { className: styles.daysLeft }, remainingDays, ' ', _this.props.translate('rocketPromotion', 'daysLeft')))) }));};_this.




    toggleRocketPromoted = function (property, activationAnotherPromotion) {var
      rocketValidUntil = property.rocket_valid_until,isActive = property.is_active;

      var isRocketPromoted = (0, _helpers2.default)(property);

      var today = (0, _moment2.default)();
      var expirationDate = (0, _moment2.default)(rocketValidUntil);
      var remainingDays = expirationDate.diff(today, 'days') > 0 ?
      expirationDate.diff(today, 'days') + 1 : 1;
      var formattedDate = (0, _moment2.default)(rocketValidUntil).format('DD/MM/YYYY');
      if (!isActive) return undefined;

      if (isRocketPromoted) {
        return _this.showMessageModal(remainingDays, formattedDate, activationAnotherPromotion);
      }
      return _this.props.openBuyModalRocketModal(property.id);
    };_this.

    handleChoosePackage = function (packageInstance) {
      _this.props.hideBuyModalRocketModal();
      _this.props.changeSelectedPayment({
        type: packageInstance.type,
        checked: packageInstance.id,
        property_id: _this.props.buyRocketPromotion.idProperties,
        period: packageInstance.periods }).

      then(function () {
        _this.props.openDetailsToInvoiceForm(Object.assign({},
        packageInstance, {
          checked: packageInstance.id,
          period: packageInstance.periods }));

      });
    };_this.

    renderPriceButton = function () {var
      currentSorting = _this.props.currentSorting;
      var iconName = currentSorting === '-price' ? 'arrow-down' : 'arrow-up';
      return (
        _react2.default.createElement('a', { onClick: _this.props.sortUserProperties, className: styles.priceButton },
          _react2.default.createElement('span', null, _this.props.translate('managePage', 'price')), '\xA0\xA0',
          !!currentSorting && _react2.default.createElement('span', { className: 'icon icon-' + iconName })));


    };_this.

































































    renderDesktopContent = function () {
      if (_this.props.isMobile) {return null;}var _this$props =

      _this.props,translate = _this$props.translate,properties = _this$props.properties,selectedProperties = _this$props.selectedProperties,currentPaginationStep = _this$props.currentPaginationStep;var
      rowsOnPage = _this.state.rowsOnPage;
      var firstIndex = currentPaginationStep - 1;
      var selectedPropertiesCounter = _this.countSelectedProperties();
      var filteredColumns = _this.transformFilteredNotions();
      var isSelected = function isSelected(property) {return selectedProperties.some(function (element) {return element.id === property.id;});};

      return (
        _react2.default.createElement('div', { className: styles.tableWrapper },
          _react2.default.createElement('table', null,
            _react2.default.createElement('thead', null,
              _react2.default.createElement('tr', null,
                _react2.default.createElement('th', { colSpan: 2 }, selectedPropertiesCounter,
                  selectedPropertiesCounter && _react2.default.createElement('span', { className: styles.selectedCount }, translate('managePage', 'selected'))),

                _react2.default.createElement('th', null, translate('managePage', 'dealType')),
                _this.checkFilteredOption('status') && _react2.default.createElement('th', { className: styles.narrowColumns }, translate('managePage', 'status')),
                _react2.default.createElement('th', { className: styles.addressBlockhead }, translate('managePage', 'address'),
                  _react2.default.createElement('span', { className: styles.publishDateHead }, ', ' + translate('managePage', 'publishDate'))),

                _react2.default.createElement('th', null, translate('managePage', 'propertyType')),
                _react2.default.createElement('th', null, _this.renderPriceButton()),
                _this.checkFilteredOption('rooms') && _react2.default.createElement('th', { className: styles.narrowColumns }, translate('managePage', 'rooms')),
                _this.checkFilteredOption('floor') && _react2.default.createElement('th', { className: styles.narrowColumns }, translate('managePage', 'floor')),
                _this.checkFilteredOption('images') && _react2.default.createElement('th', null, translate('managePage', 'images')),
                _this.checkFilteredOption('exposures') && _react2.default.createElement('th', null, translate('managePage', 'exposures')),
                _this.checkFilteredOption('phoneClicksCount') && _react2.default.createElement('th', null, translate('managePage', 'phoneClicksCount')),
                _this.checkFilteredOption('favouritesCount') && _react2.default.createElement('th', null, translate('managePage', 'favouritesCount')),
                _react2.default.createElement('th', null, translate('managePage', 'share')),
                _react2.default.createElement('th', null, translate('managePage', 'activePromotion')),
                _react2.default.createElement('th', null))),


            _react2.default.createElement('tbody', null,

              properties.map(function (property) {return (
                  _react2.default.createElement(_TableRow2.default, _extends({
                    toggleRocketPromoted: _this.toggleRocketPromoted,
                    isPublishPermissionsForeign: _this.props.isPublishPermissionsForeign,
                    key: property.id,
                    property: property,
                    handleCheck: _this.handleCheck,
                    isSelected: isSelected(property),
                    openBuyModalRocketModal: _this.props.openBuyModalRocketModal,
                    numberInOrder:
                    _this.props.properties.map(function (_ref2) {var propId = _ref2.id;return propId;}).indexOf(property.id) + currentPaginationStep },

                  (0, _omit2.default)(_this.props, ['properties']), {
                    filterredColumns: filteredColumns })));})))));






    };_this.

    renderMobileContent = function () {
      if (!_this.props.isMobile) {return null;}var _this$props2 =
      _this.props,properties = _this$props2.properties,selectedProperties = _this$props2.selectedProperties,currentPaginationStep = _this$props2.currentPaginationStep,isNative = _this$props2.isNative;
      var isSelected = function isSelected(property) {return selectedProperties.some(function (element) {return element.id === property.id;});};

      return properties.map(function (property) {return (
          _react2.default.createElement(_components.OMAgentManageCell, _extends({
            isPublishPermissionsForeign: _this.props.isPublishPermissionsForeign,
            key: property.id,
            property: property,
            handleCheck: _this.handleCheck,
            isSelected: isSelected(property),
            numberInOrder:
            _this.props.properties.map(function (_ref3) {var propId = _ref3.id;return propId;}).indexOf(property.id) + currentPaginationStep,

            openMessageModal: _this.props.openMessageModal,
            toggleRocketPromoted: _this.toggleRocketPromoted,
            isNative: isNative },
          (0, _omit2.default)(_this.props, ['properties']))));});


    };_this.

    renderBuyRocketPromotion = function () {return (
        _this.props.buyRocketPromotion.isBuyRocketModalOpen &&
        _react2.default.createElement(_containers.BuyRocketPromotion, {
          translate: _this.props.translate,
          buyRocketPromotion: _this.props.buyRocketPromotion,
          isOpen: true,
          onRequestClose: _this.props.hideBuyModalRocketModal,
          openBuyModalRocketModal: _this.props.openBuyModalRocketModal,
          isMobile: _this.props.isMobile,
          locale: _this.props.locale,
          handleChoosePackage: _this.handleChoosePackage }));};_this.state = { selectedProperties: props.selectedProperties, step: 5, rowsOnPage: { value: 10, label: 10 }, selected: 1 };return _this;}PropertiesTable.prototype.componentDidMount = function componentDidMount() {this.getPagination('rows-on-page');};PropertiesTable.prototype.componentWillReceiveProps = function componentWillReceiveProps(newProps) {var loadedNewPage = this.props.properties && this.props.properties.length && JSON.stringify(newProps.properties.map(function (item) {return item.id;})) !== JSON.stringify(this.props.properties.map(function (item) {return item.id;}));if (loadedNewPage) {this.props.performAnalyticsQueries(newProps.properties.map(function (item) {return item.id;}));}if (this.props.selectedProperties.length !== newProps.selectedProperties.length) {this.setState({ selectedProperties: newProps.selectedProperties });}if (this.props.currentPaginationStep !== newProps.currentPaginationStep) {this.setState({ selected: newProps.currentPaginationStep });this.props.paginationUserProperties();}};PropertiesTable.prototype.renderPagination = function renderPagination() {var _this2 = this;var _props = this.props,translate = _props.translate,properties = _props.properties,currentPaginationStep = _props.currentPaginationStep,propertiesCount = _props.propertiesCount;var rowsOnPage = this.state.rowsOnPage;var nextStart = currentPaginationStep + rowsOnPage.value - 1;var lastProperty = nextStart < propertiesCount ? nextStart : propertiesCount;var options = [{ value: 10, label: 10 }, { value: 50, label: 50 }, { value: 100, label: 100 }];var desktopPagination = _react2.default.createElement('div', { className: styles.paginationBlock }, _react2.default.createElement('div', { className: styles.navigateBtn }, _react2.default.createElement('button', { onClick: this.handleForward, className: styles.forwardBtn }, _react2.default.createElement('span', { className: 'icon-back' })), _react2.default.createElement('button', { onClick: this.handleBack, className: styles.backBtn }, _react2.default.createElement('span', { className: 'icon-back' }))), _react2.default.createElement('span', null, currentPaginationStep + '-' + lastProperty + ' ' + translate('managePage', 'of') + ' ' + propertiesCount), _react2.default.createElement('div', { className: styles.inputSection }, _react2.default.createElement('span', null, translate('managePage', 'goTo')), _react2.default.createElement('div', { className: styles.inputWrapper }, _react2.default.createElement('input', { type: 'text', value: this.state.selected, onChange: function onChange(val) {return _this2.handleGoTo(+val.target.value);} }))), _react2.default.createElement('div', { className: styles.inputSection }, _react2.default.createElement('span', { className: styles.showRows }, translate('managePage', 'showRows')), _react2.default.createElement(_Select2.default, { name: 'rows-on-page', value: this.state.rowsOnPage, options: options, onChange: this.changePagination, clearable: false, searchable: false })));var mobilePagination = _react2.default.createElement('div', { className: styles.paginationBlock }, _react2.default.createElement('button', { onClick: this.handleForward, className: styles.forwardBtn }, _react2.default.createElement('span', { className: 'icon-back' })), _react2.default.createElement('span', null, currentPaginationStep + '-' + lastProperty + ' ' + translate('managePage', 'of') + ' ' + propertiesCount), _react2.default.createElement('div', { className: styles.inputSection }, _react2.default.createElement('span', { className: styles.showRows }, translate('managePage', 'showRows')), _react2.default.createElement(_Select2.default, { className: styles.rowsOnPage, name: 'rows-on-page', value: this.state.rowsOnPage, options: options, onChange: this.changePagination, clearable: false, searchable: false })), _react2.default.createElement('button', { onClick: this.handleBack, className: styles.backBtn }, _react2.default.createElement('span', { className: 'icon-back' })));return this.props.isMobile ? mobilePagination : desktopPagination;};PropertiesTable.prototype.



  render = function render() {
    return (
      _react2.default.createElement('div', { className: styles.componentWrapper },
        _react2.default.createElement(_reactScroll.Element, { name: 'anchor-top' }),
        this.renderDesktopContent(),
        this.renderMobileContent(),
        this.renderPagination(),
        this.renderBuyRocketPromotion()));


  };return PropertiesTable;}(_react.Component);exports.default = PropertiesTable;


PropertiesTable.propTypes = {
  translate: _propTypes2.default.func,
  isMobile: _propTypes2.default.bool,
  isRtl: _propTypes2.default.bool,
  properties: _propTypes2.default.array,
  locale: _propTypes2.default.string.isRequired,
  editProperty: _propTypes2.default.func.isRequired,
  openDetailsPopup: _propTypes2.default.func.isRequired,
  updatePropertyActivity: _propTypes2.default.func.isRequired,
  updatePropertyHighlighting: _propTypes2.default.func.isRequired,
  openContactUsModal: _propTypes2.default.func.isRequired,
  selectedProperties: _propTypes2.default.array.isRequired,
  updateSelectedProperties: _propTypes2.default.func.isRequired,
  propertiesAnalytics: _propTypes2.default.array,
  movePropertyToTop: _propTypes2.default.func,
  closeMobileFilters: _propTypes2.default.func,
  mobileFiltersIsOpen: _propTypes2.default.bool,
  openChartOfViews: _propTypes2.default.func,
  updateAutoJumpToTopActivity: _propTypes2.default.func,
  updateTopPromotionActivity: _propTypes2.default.func,
  loadSinglePropertyAnalytics: _propTypes2.default.func,
  performAnalyticsQueries: _propTypes2.default.func,
  setCurrentPaginationStep: _propTypes2.default.func,
  currentPaginationStep: _propTypes2.default.number,
  openMessageModal: _propTypes2.default.func,
  jumpPromotion: _propTypes2.default.object,
  promotion: _propTypes2.default.object,
  top_promotion: _propTypes2.default.object,
  selectedColumns: _propTypes2.default.array,
  currentSorting: _propTypes2.default.string,
  sortUserProperties: _propTypes2.default.func,
  isPublishPermissionsForeign: _propTypes2.default.bool,
  buyRocketPromotion: _propTypes2.default.object,
  openBuyModalRocketModal: _propTypes2.default.func,
  hideBuyModalRocketModal: _propTypes2.default.func,
  changeSelectedPayment: _propTypes2.default.func,
  paginationUserProperties: _propTypes2.default.func,
  propertiesCount: _propTypes2.default.number,
  openDetailsToInvoiceForm: _propTypes2.default.func,
  isNative: _propTypes2.default.bool };module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/PropertiesTable/PropertiesTable.js
// module id = 2986
// module chunks = 0